import { createFileRoute } from '@tanstack/react-router'

import { AchVolumeTrendsScreen } from './-components/ach-volume-trends-screen.tsx'

export const Route = createFileRoute('/ach/volume-trends')({
  component: AchVolumeTrendsScreen
})
